import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { pluralize } from 'humanize-plus'
import { Link } from 'react-router'
import moment from 'moment'
import InlineSvg from 'svg-inline-react'
import classnames from 'classnames'
import { compose, branch, renderComponent } from 'recompose'
import { ProgressiveLoader } from '@driftt/tide-core-legacy'
import * as ConversationSelectors from 'app/modules/conversation/selectors'
import * as ConversationActions from 'app/modules/conversation/actions'
import { track } from 'app/modules/tracking/actions'
import ConversationApi from 'app/modules/conversation/api'

import {
  PLACEHOLDER_PRIMARY_COLOR,
  PLACEHOLDER_SECONDARY_COLOR,
  PLACEHOLDER_PRIMARY_OPACITY,
  PLACEHOLDER_SECONDARY_OPACITY,
} from 'components/conversation/ContactSideBar'

import colors from 'styles/colors.json'
import { SectionHeader } from './SectionHeader.styl'
import { SectionBody, Table, ViewTimeLine } from './SectionBody.styl'
import { activitySectionPlaceholder } from './style.styl'

export const RolodexIcon = (
  <InlineSvg
    style={{
      width: 16,
      height: 11,
      marginRight: 8,
    }}
    element="div"
    src={require('!svg-inline?removeTags=true!images/svg/rolodex.svg')}
  />
)

const Selection = ({ onClick, count, noun, isSelected }) => {
  return (
    <div
      className={classnames('flex-column flex-center', { 'bg-navy-light': isSelected })}
      onClick={onClick}
      style={{
        border: `1px solid ${colors['color-navy-light']}`,
        borderRadius: 3,
        height: 60,
        width: 110,
        cursor: 'pointer',
        marginBottom: 16,
        transition: 'all .3s',
      }}
    >
      <span
        className="dsg-h2 color-blue"
        style={{
          lineHeight: '30px',
        }}
      >
        {count}
      </span>
      <span className="dsg-Small color-navy-dark">{noun}</span>
    </div>
  )
}

const ActivitySectionPlaceholder = () => {
  const placeholderShape = [
    <rect key={0} x="0" y="0" width="229" height="27" rx="2"></rect>,
    <rect key={1} x="0" y="47" width="229" height="27" rx="2"></rect>,
    <rect key={2} x="0" y="94" width="229" height="27" rx="2"></rect>,
  ]

  const options = {
    height: 131,
    width: 229,
    primaryColor: PLACEHOLDER_PRIMARY_COLOR,
    secondaryColor: PLACEHOLDER_SECONDARY_COLOR,
    primaryOpacity: PLACEHOLDER_PRIMARY_OPACITY,
    secondaryOpacity: PLACEHOLDER_SECONDARY_OPACITY,
  }

  return (
    <div className={activitySectionPlaceholder}>
      <ProgressiveLoader options={options} placeholderShape={placeholderShape} numPlaceholders={1} />
    </div>
  )
}

class ActivitySection extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showChats: true,
      conversations: [],
    }
  }

  componentDidMount() {
    this.props.actions.fetchConversationsCountForEndUserId({ id: this.props.endUserId })
    ConversationApi.fetchConversationsForEndUser(this.props.endUserId)
      .then((conversations) => {
        this.setState({ conversations })
      })
  }

  getChatRows() {
    return this.state.conversations
      .map(({ inboxId, id, preview, updatedAt }) => (
        <Link to={`/inboxes/${inboxId}/conversations/${id}`} key={id} onClick={() => track('Conversation Sidebar - Go To Conversation Clicked')}>
          <span className="flex-1">{preview}</span>
          <span style={{ width: 55 }}>{moment(updatedAt).format('M/D/YY')}</span>
        </Link>
      ))
  }

  render() {
    const { showChats } = this.state
    const { conversationCount, endUserId } = this.props
    return (
      <div>
        <div className={SectionHeader}>
          {RolodexIcon}
          Activity
        </div>
        <div className={SectionBody}>
          <div className="flex-space-between">
            <Selection
              onClick={this.showChatRows}
              count={conversationCount}
              noun={pluralize(conversationCount, 'chat', 'chats')}
              isSelected={showChats}
            />
          </div>
          <div className={Table}>{this.getChatRows()}</div>
          <Link className={`${ViewTimeLine} flex-center`} to={`/contacts/details/${endUserId}`} target="_blank">
            View Full Timeline
          </Link>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, props) => ({
  conversationCount: ConversationSelectors.conversationCountForEndUser(state, { endUserId: props.endUserId }),
})

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({
    fetchConversationsCountForEndUserId: ConversationActions.fetchConversationsCountForEndUserId,
  }, dispatch)
})

export default compose(
  branch(
    props => !props.endUserId,
    renderComponent(ActivitySectionPlaceholder),
  ),
  connect(mapStateToProps, mapDispatchToProps),
)(ActivitySection)



// WEBPACK FOOTER //
// ./src/scripts/components/conversation/ContactSideBar/Person/ActivitySection/index.js